import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "form-slot__info" }
const _hoisted_2 = { class: "form-slot__info--icon m-right-25" }
const _hoisted_3 = { class: "icon-form" }
const _hoisted_4 = {
  key: 0,
  class: "icon-check"
}
const _hoisted_5 = { class: "form-slot__info--title" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Signed")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Sign through ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.docusign.com/products/electronic-signature/how-docusign-works",
  rel: "noopener noreferrer",
  target: "_blank"
}, "DocuSign", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconForm = _resolveComponent("IconForm")!
  const _component_IconCheck = _resolveComponent("IconCheck")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-slot", { loader: _ctx.loader }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_IconForm)
        ]),
        (_ctx.signed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_IconCheck)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1),
        _createElementVNode("span", null, [
          (_ctx.signed)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_6
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_7,
                _hoisted_8
              ], 64))
        ])
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}